var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMidOptionOptionDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4px",
    height: "20px",
    viewBox: "0 0 4 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "colour/mid-grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.81818182,4 C0.814027728,4 0,3.1045695 0,2 C0,0.8954305 0.814027728,0 1.81818182,0 C2.82233591,0 3.63636364,0.8954305 3.63636364,2 C3.63636364,3.1045695 2.82233591,4 1.81818182,4 Z M10,4 C8.99584591,4 8.18181818,3.1045695 8.18181818,2 C8.18181818,0.8954305 8.99584591,0 10,0 C11.0041541,0 11.8181818,0.8954305 11.8181818,2 C11.8181818,3.1045695 11.0041541,4 10,4 Z M18.1818182,4 C17.1776641,4 16.3636364,3.1045695 16.3636364,2 C16.3636364,0.8954305 17.1776641,0 18.1818182,0 C19.1859723,0 20,0.8954305 20,2 C20,3.1045695 19.1859723,4 18.1818182,4 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-5-Friend-Request",
    transform: "translate(-992.000000, -227.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Name",
    transform: "translate(476.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(518.000000, 16.000000) rotate(-90.000000) translate(-518.000000, -16.000000) translate(508.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#333333",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31.8181818,
    height: 31.25
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidOptionOptionDesktop);
export default __webpack_public_path__ + "static/media/midOptionOptionDesktop.c36d81e1661e7cd0876ab6d2ad433bb5.svg";
export { ForwardRef as ReactComponent };